import { Button, Flex } from 'pcln-design-system';
import React, { useContext, useState } from 'react';
import { ChatbotDataContext } from './context/ChatbotDataContext';
export var QuickActions = function (props) {
    var submitQuickActionMessage = props.submitQuickActionMessage, hasOtherMessage = props.hasOtherMessage;
    var _a = useState(true), isQuickActionsDisplayed = _a[0], setQuickActionsDisplayedValue = _a[1];
    var _b = useContext(ChatbotDataContext), _c = _b.quickActions, quickActions = _c === void 0 ? [] : _c, isMobile = _b.isMobile;
    if (!quickActions.length || hasOtherMessage || !isQuickActionsDisplayed) {
        return null;
    }
    return (React.createElement(Flex, { flexDirection: isMobile ? 'column' : 'row', alignItems: 'center', p: 2, flexWrap: 'wrap' }, quickActions.map(function (action, i) { return (React.createElement(Flex, { key: "quick-action-button-".concat(i), my: 2, mx: 1, alignItems: 'center', width: isMobile ? 1 : '' },
        React.createElement(Button, { boxShadowSize: 'sm', variation: 'white', onClick: function () {
                submitQuickActionMessage(action);
                setQuickActionsDisplayedValue(false);
            }, width: isMobile ? 1 : '' }, action.label))); })));
};
//# sourceMappingURL=QuickActions.js.map